import zonedTimeToUtc from 'date-fns-tz/zonedTimeToUtc';
import defaultTimezone from 'Common/constants/defaultTimezone';

const formatDateAsISO = date =>
    zonedTimeToUtc(date, defaultTimezone).toISOString();

export default formatDateAsISO;
